import { Card, Typography, Chip, Tooltip, IconButton } from '@material-tailwind/react'
import { TbDoor } from 'react-icons/tb'
import { norm } from './utils'

export function HistoryCard({ inv, onOpenUsage, fmt }) {
  const vd = inv?.visitor_data || {}
  const alias = vd.token_name && norm(vd.token_name) !== norm(vd.name)
  const company = vd.origin_company || vd.company_name || null
  const derived = inv?.final_state
  const invitedBy = inv?.created_by_name || null
  const acceptedBy = inv?.approved_by_name || null
  const sameUser   = invitedBy && acceptedBy && norm(invitedBy) === norm(acceptedBy)

  const nameColor   = derived === 'rejected' ? 'text-red-800'   : 'text-green-800'
  const bgTint      = derived === 'rejected' ? 'bg-red-50'      : 'bg-green-50'
  const outerBorder = derived === 'rejected' ? 'border-red-200' : 'border-green-200'
  const leftAccent  = derived === 'rejected' ? 'border-l-red-600' : 'border-l-green-600'

  return (
    <Card
      className={`w-full p-4 border ${outerBorder} ${bgTint} relative pl-5 border-l-4 ${leftAccent}`}
      aria-label={derived === 'rejected' ? 'Invitación rechazada' : 'Invitación aprobada'}
    >
      {/* Badge de estado */}
      <div className="absolute top-2 right-2">
        <Chip
          value={derived === 'rejected' ? 'Rechazada' : 'Aprobada'}
          size="sm"
          color={derived === 'rejected' ? 'red' : 'green'}
        />
      </div>

      {/* Icono de registro de usos (si existe usage_data) */}
      {!!inv?.usage_data?.events?.length && (
        <div className="absolute bottom-2 right-2">
          <Tooltip content="Ver registro de usos">
            <IconButton
              variant="text"
              className="bg-white/80 hover:bg-white rounded-full shadow-sm"
              onClick={() => onOpenUsage(inv)}
              aria-label="Ver registro de usos"
              title="Ver registro de usos"
            >
              <TbDoor className="h-5 w-5" />
            </IconButton>
          </Tooltip>
        </div>
      )}

      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">
        <div className="min-w-0 pr-8">
          <Typography className={`font-semibold truncate ${nameColor}`}>
            {vd.name || '—'}
          </Typography>
          {alias && <p className="text-xs italic text-gray-600 truncate">{vd.token_name}</p>}
          {company && <p className="text-xs text-gray-700 truncate">{company}</p>}
          <p className="text-sm text-gray-700 truncate">{vd.email || '—'}</p>
          {vd.document_number && <p className="text-xs text-gray-600 truncate">Doc: {vd.document_number}</p>}
          {vd.host_person && <p className="text-xs text-gray-600 truncate">Visita a: {vd.host_person}</p>}
          {sameUser && (
            <p className="text-[11px] text-gray-600 mt-0.5 truncate">
              Invitado y aceptado por: {invitedBy}
            </p>
          )}
          {!sameUser && invitedBy && (
            <p className="text-[11px] text-gray-600 mt-0.5 truncate">
              Invitado por: {invitedBy}
            </p>
          )}
          {!sameUser && acceptedBy && (
            <p className="text-[11px] text-gray-600 mt-0.5 truncate">
              Aceptado por: {acceptedBy}
            </p>
          )}
        </div>
        <div className="text-sm text-gray-800">
          <p className="font-medium truncate">{inv.office_name}</p>
          <p className="text-xs">Creada: {fmt(inv.created_at)}</p>
          <p className="text-xs">Ventana: {fmt(inv.starts_at)} – {fmt(inv.ends_at)}</p>
        </div>
      </div>
    </Card>
  )
}
